declare const Sentry: any;

export const logSentry = (e) => {
    Sentry.withScope((scope) => {
        scope.setTags({
            'page': e.page,
            'feature': e.feature,
            'operation': e.operation,
            'errorType': e.errorType
        })
        scope.setExtras({
            'exception': JSON.stringify(e.err),
            'function': e.func,
            'api': e.api
        });

        Sentry.captureException(new Error(e.errMsg));
    });
}
export const logSentryTransacation = (transactionName) => {
    try {
      const transaction = Sentry.startTransaction({ name: transactionName });
      return transaction;
    } catch (error) {
      console.log(error);
    }
};
